import React, { useEffect, useRef, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { checkedState, unCheckedState, checkedAllState, unCheckedAllState, setComments, SingleApproveOrRejectAsync } from '../../taskrequesthours/taskRequestHoursSlice'
import moment from 'moment';
import '../../../common/css/timeLive.css'
import './TaskRequestApproval.css'
import { ShowSwalWithConfirmation, ShowSwalWithConfirmationMessage } from '../../../common/SweetAlert';
import { ShowToast } from '../../../common/Toastr';
import { formatDateWithDateAndMonthName, FormatInvoiceDecimalNumber, getValueFromResource } from '../../../common/timeLiveFunction';
const TaskRequestApprovalItem = (props: any) => {
    const { taskRequestApprovalList, t, IsEdit } = props;
    const dispatch = useAppDispatch();
    const { isReload, selectedRecord, isLoading, startDate, endDate, CurrentCultureName } = useAppSelector((state) => state.taskRequestHours);
    const { decimalPlaces, cultureInfoName } = useAppSelector((state) => state.globalState)
    const popupRef = useRef<any>(null);
    const approvedButtonRef = useRef<any>(null);
    const rejectedButtonRef = useRef<any>(null);
    const modelRef = useRef<any>(null);
    const [id, setId] = useState(null);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [showPrint, setShowPrint] = useState(false);
    const [data, setData] = useState({
        expenseApprovalObject: {},
        filterProjects: '',
        filterEmployees: ''
    });

    useEffect(() => {
        if (modalIsOpen) {
            if (modelRef.current) {
                modelRef.current.click();
            }
        }
    }, [modalIsOpen])

    const handleCommentsChange = (e: any, AccountTaskRequestId: any) => {
        dispatch(setComments({ AccountTaskRequestId: AccountTaskRequestId, Comments: e.target.value }))
    };

    const handleButtonClick = (e: any, AccountTaskRequestId: any) => {
        let id = e.currentTarget.id;
        ShowSwalWithConfirmationMessage(`Are you sure you want to ${id} this record?`, "", `Yes, Proceed`)
            .then((result) => {
                if (result) {
                    const foundItems = taskRequestApprovalList.filter((item: any) => item.AccountTaskRequestId === AccountTaskRequestId);
                    if (foundItems) {
                        dispatch(SingleApproveOrRejectAsync({ List: foundItems, id: id }))
                            .unwrap()
                            .then((originalPromiseResult) => {
                                originalPromiseResult.StatusCode === "200" ?
                                    ShowToast(`${id === "Approve" ? "Approved" : "Rejected"} Successfully`, 'Success', "success", "toast-top-right") :
                                    ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                            })
                            .catch((rejectedValueOrSerializedError) => {

                            })
                    }
                }
            })
            .catch((error) => {
            });
    }

    useEffect(() => {
        if (Object.keys(data.expenseApprovalObject).length > 0) {
            setShowPrint(true);
        }
    }, [data])

    const handleSelectAllChange = (e: any) => {
        const { checked } = e.target;
        if (checked) {
            dispatch(checkedAllState());
        } else {
            dispatch(unCheckedAllState());
        }
    }

    const handleCheckboxChange = (e: any, rowId: any) => {
        if (e.target.checked) {
            dispatch(checkedState(rowId))
        } else {
            dispatch(unCheckedState(rowId))
        }
    }

    return (
        <>
            <table className="table table-row-bordered  align-middle gs-1 gy-1 gx-1" >
                <thead>
                    <tr className="thHeading align-middle">
                        {IsEdit ? (
                            <th className='w-25px'>
                                <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox' >
                                    <input
                                        className='form-check-input'
                                        type='checkbox'
                                        checked={taskRequestApprovalList.every((item: any) => item.isSelected === 0) ? false :
                                            (taskRequestApprovalList.every((item: any) => item.isSelected === 1 ? true : false))
                                        }
                                        onChange={handleSelectAllChange}
                                    />
                                </div>
                            </th>
                        ) : null}
                            <th className='w-20'>
                             {getValueFromResource('Employee Name',dispatch, t)}
                            </th>
                        <th className='w-25'>
                             {getValueFromResource('Task Name',dispatch, t)}
                            </th>
                            <th className='w-20'>
                             {getValueFromResource('Project Name',dispatch, t)}
                            </th>
                        <th className='w-20'>
                             {getValueFromResource('Reason',dispatch, t)}
                            </th>
                        <th className='w-10'>
                             {getValueFromResource('Previous Hours',dispatch, t)}
                            </th>
                        <th className='w-10'>
                             {getValueFromResource('Requested Hours',dispatch, t)}
                            </th>
                        {IsEdit ? (
                            <th className='w-250px'></th>
                        ) : null}
                        <th className='w-25px text-center'></th>
                    </tr>
                </thead>
                <tbody>
                    {/* {taskRequestApprovalList.length === 0 && <tr><td colSpan={8}><p className='noDataFound'>{t('No Record Found')}</p></td></tr>} */}
                    {taskRequestApprovalList.length > 0 && taskRequestApprovalList.map((taskRequestApproval: any, i: any) => (
                        (taskRequestApproval.isFiltered === 1 || taskRequestApproval.isFiltered === -1) && (
                            <tr key={i}>
                                {IsEdit ? (
                                    <td>
                                        <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox' >
                                            <input
                                                type="checkbox"
                                                className="form-check-input widget-9-check "
                                                checked={taskRequestApproval.isSelected == 0 ? false : true}
                                                onChange={(e) => { handleCheckboxChange(e, taskRequestApproval.AccountTaskRequestId) }}
                                            />
                                        </div>
                                    </td>
                                ) : null}
                                 <td>
                                    {taskRequestApproval.SubmittedEmployeeName !== "" ? (
                                        taskRequestApproval.SubmittedEmployeeName
                                    ) : null}
                                </td>
                                <td>
                                    {taskRequestApproval.TaskName}
                                    <br />
                                    <span style={{ color: '#7b8ba6', fontSize: 11 }}>
                                        <i className="ki-outline ki-calendar text-gray fs-6 me-2 "></i>
                                        {/* {moment.parseZone(taskRequestApproval.TaskRequestCreatedDate).format('M/D/YYYY')} */}
                                        {formatDateWithDateAndMonthName(taskRequestApproval.TaskRequestCreatedDate, cultureInfoName.toString())}
                                    </span>
                                </td>
                                <td>
                                    {taskRequestApproval.ProjectName !== "" ? (
                                        taskRequestApproval.ProjectName
                                    ) : null}
                                </td>
                                <td>
                                    {taskRequestApproval.Reason !== "" ? (
                                        taskRequestApproval.Reason
                                    ) : null}
                                </td>
                                <td>
                                    {/* {`${taskRequestApproval.LastAllocationHours ? taskRequestApproval.LastAllocationHours.toLocaleString(CurrentCultureName, { minimumFractionDigits: 2 }) : '0.00'}`} */}
                                    {`${taskRequestApproval.LastAllocationHours ? FormatInvoiceDecimalNumber(cultureInfoName.toString(),taskRequestApproval.LastAllocationHours,2) : FormatInvoiceDecimalNumber(cultureInfoName.toString(), 0 , 2)}`}
                                </td>
                                <td>
                                    {/* {`${taskRequestApproval.NewAllocationHours ? taskRequestApproval.NewAllocationHours.toLocaleString(CurrentCultureName, { minimumFractionDigits: 2 }) : '0.00'}`} */}
                                    {`${taskRequestApproval.NewAllocationHours ? FormatInvoiceDecimalNumber(cultureInfoName.toString(), taskRequestApproval.NewAllocationHours , 2) : FormatInvoiceDecimalNumber(cultureInfoName.toString(), 0 , 2)}`}

                                </td>
                                {IsEdit ? (
                                    <td className='p-0 m-0'>
                                        <button
                                            id="Approve"
                                            ref={approvedButtonRef}
                                            className={`btn btn-outline btn-sm btn-outline me-0 mb-0 btn-active-light-dark  me-1`}
                                            onClick={(e: any) => handleButtonClick(e, taskRequestApproval.AccountTaskRequestId)}
                                        >
                                            <i className="bi bi-check iconApprove p-0"></i>
                                            <span style={{ color: '#009688' }}>
                                                {/* {t('Approved')} */}
                                                {getValueFromResource('Approve',dispatch, t)}
                                                </span>
                                        </button>
                                        <button
                                            id="Reject"
                                            ref={rejectedButtonRef}
                                            className={`btn btn-outline btn-sm btn-outline me-0 mb-0 btn-active-light-dark`}
                                            onClick={(e: any) => handleButtonClick(e, taskRequestApproval.AccountTaskRequestId)}
                                        >
                                            <i className="bi bi-x iconReject p-0"></i>
                                            <span style={{ color: '#E53935' }}>
                                                 {/* {t('Rejected')} */}
                                                 {getValueFromResource('Reject',dispatch, t)}
                                                 </span>
                                        </button>
                                    </td>
                                ) : null}
                                <td>

                                    <div className="btn-group" style={{ float: 'right' }}>
                                        <a
                                            className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                            data-tooltip-id="tooltip-Description"
                                            data-tooltip-content=
                                            // {t("Approvers Comment")}
                                            {getValueFromResource('Approvers Comment',dispatch, t)}
                                            data-tooltip-place="bottom">
                                            <i className="bi bi-chat-square-text fs-3 iconColor"></i>
                                        </a>
                                        <ul className="dropdown-menu menu-column menu-rounded menu-gray-600 px-4 py-4 fs-2 w-300px" role="menu">
                                            <div className='menu-item text-gray-800'>
                                                <div className="dropdown-menu-item">
                                                    <textarea
                                                        placeholder=
                                                        // {t("Your comments here...")}
                                                        {getValueFromResource('Your comments here...',dispatch, t)}
                                                        className="form-control fs-7 fw-normal"
                                                        rows={4}
                                                        style={{ borderRadius: 2 }}
                                                        onChange={(e) => handleCommentsChange(e, taskRequestApproval.AccountTaskRequestId)}
                                                        value={taskRequestApproval.Comments}
                                                    />
                                                </div>
                                            </div>
                                        </ul>
                                    </div>
                                </td>
                            </tr>
                        )
                    ))}
                </tbody>
            </table>
            {taskRequestApprovalList.length === 0 &&
                <div className=''>
                    <p className='noDataFound'>
                        {/* {t('No Record Found')} */}
                        {getValueFromResource('No Record Found',dispatch, t)}
                        </p>
                </div>
            }
        </>
    )
}

export default TaskRequestApprovalItem

